module.exports = __webpack_public_path__ + "img/whaleex.435ad00a.png";